<template>
  <router-link tag="button" :to="{name: routeName, params: routeParameters }" class="tile">
    <h2>{{title}}</h2>
    <img :src="previewImageSrc" :alt="previewImageAlt" />
    <p class="title-preview">
      <slot>No content</slot>
    </p>
  </router-link>
</template>

<script>
export default {
  name: 'tile',
  props: [
    'title',
    'route-name',
    'preview-image-src',
    'preview-image-alt',
    'route-parameters'
  ]
}
</script>

<style lang="scss" scoped>
.tile {
  border: 3px solid #42b983;
  border-radius: 5px;
  padding: 10px;
  max-width: 24%;
  margin-top: 10px;
  background: #000;
  color: #fff;
  text-align: left;
  align-self: flex-start;
  box-shadow: 2px 2px 5px 3px #000;
  cursor: pointer;
  &:hover {
    animation: enlarge 1s both;
    z-index: 100;
  }

  &:nth-child(1) {
    transform: rotate(12deg);
  }
  &:nth-child(2) {
    transform: rotate(-15deg);
  }
  &:nth-child(3) {
    transform: rotate(20deg);
  }
  &:nth-child(4) {
    transform: rotate(-12deg);
  }
  &:nth-child(5) {
    transform: rotate(12deg);
  }

  @media screen and (max-width: 762px) {
    max-width: none;
    width: 100%;
    &:nth-child(1) {
      transform: rotate(0deg);
    }
    &:nth-child(2) {
      transform: rotate(0deg);
    }
    &:nth-child(3) {
      transform: rotate(0deg);
    }
    &:nth-child(4) {
      transform: rotate(0deg);
    }
    &:nth-child(5) {
      transform: rotate(0deg);
    }
    &:hover {
      animation: none;
    }
  }

  h2 {
    margin-top: 0;
  }

  img {
    width: 100%;
  }

  .title-preview {
    margin-bottom: 0;
  }

  @keyframes enlarge {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.3) rotate(0deg);
    }
  }
}
</style>
